// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
import * as React from "react";
import SimpleNotificationCard from "blocks/views/Notifications/foundations/SimpleNotificationCard";
import { getS3ImageWrapper } from "@app21/core";

const UserAddedOrganization = ({ notification, viewContext, index }) => {
  const { payload } = notification;

  const data = {
    message: `${
      payload?.addedUserFullName || "New Member"
    } has been added to Organization ${payload?.organizationFullName}`,
    avatar: getS3ImageWrapper(payload?.addedUserImage),
    subHeader: notification.createdAt,
  };
  return (
    <SimpleNotificationCard
      data={data}
      notification={notification}
      viewContext={viewContext}
      index={index}
    />
  );
};

export default UserAddedOrganization;
